const Route = {
  Home: 'home',
  Relation: 'relation',
  RelationMain: 'relation.main',
  RelationStatistics: 'relation.statistics',
  Demo: 'demo',
  Error404: 'error.404',
} as const

export { Route }
